// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1_Ew4","cls2":"NewsInteractionBar-cls2_qnt NewsInteractionBar-cls1_Ew4"};